import { useEffect, useState } from "react";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/grid';
import _ from 'lodash';

export default function Review(props) {
    const { t, providerList, title } = props;
    const providerListArray = !_.isEmpty(providerList) ? JSON.parse(providerList) : [];
    
    return (
        <>
            <div className="provider-slider">
            {!_.isEmpty(providerListArray) ? <h4>{title}</h4> : ''}
                <Swiper
                    className={"providerSwiper"}
                    modules={[Autoplay]}
                    spaceBetween={50}
                    slidesPerView={5}
                    /*
                    loop={true}
                    autoplay={{
                        delay: 1000,
                        disableOnInteraction: false
                    }}
                    */
                    breakpoints={{
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 15
                        },
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2.8,
                            spaceBetween: 22
                        },
                        992: {
                            slidesPerView: 3.8,
                            spaceBetween: 50
                        },
                        // when window width is >= 640px
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 54,
                        }
                    }}
                >
                    <div className="swiper-wrapper">
                        {
                            providerListArray.length > 0 ?
                                _.map(providerListArray, pLA => (
                                    <SwiperSlide key={pLA.provider_id}>
                                        <div className="swiper-slide">
                                            <div className="provider-box p-2" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                                                <a><img src={process.env.NEXT_PUBLIC_FS_URL+pLA.image} alt="" className="p-4 img-fluid" width={250} /></a>
                                                {/* {pLA.image} */}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                                :
                                null
                        }
                    </div>
                </Swiper>
            </div>
        </>
    )
}